<template lang="html">
  <div class="navigation"></div>
</template>

<script>
export default {
  data () {
    return {
      states: [],
      statesKeep: true,
      hasBeenPushed: true
    }
  },
  computed: {
    state() {
      return this.states[0]
    }
  },
  methods: {
    previous() {
      this.onPopState()
    },

    onPushState(state, keep = true) {
      if (!this.statesKeep) {
          this.states.shift()
      }
      this.statesKeep = keep
      this.hasBeenPushed = true
      this.states.unshift(state)
    },

    onPopState() {
      this.statesKeep = true
      this.hasBeenPushed = false
      this.states.shift()
    }
  },
}
</script>

<style lang="stylus">
.navigation
  position relative
  width 100%
  height 100%
  overflow hidden
</style>



// WEBPACK FOOTER //
// Navigation.vue?2339880a